// eslint-disable-next-line import/prefer-default-export
export enum AppyPros {
  FlexibleTransportation = 'flexibleTransportation',
}
